import React, {useState} from "react";
import {Tabs} from "antd";
import {TabsContainer} from "../../courier/courierDetail/courierDetailStyles";
import {MerchantPaymentSummaryPage} from "../summary/MerchantPaymentSummaryPage";
import {MerchantPastPeriodsTab} from "./merchantPastPeriodsTab/MerchantPastPeriodsTab";
import {CustomerCashOnDeliveryPageContainer} from "components/customer/customerCashOnDeliveryPage/style/CustomerCashOnDeliveryPage";

export const MerchantCashOnDeliveryPage = () => {
    const [activeTab, setActiveTab] = useState("summary");

    return (
        <CustomerCashOnDeliveryPageContainer>
            <TabsContainer activeKey={activeTab} onChange={key => setActiveTab(key)}>
                <Tabs.TabPane tab="Özet" key="summary">
                    <MerchantPaymentSummaryPage isTabOpened={activeTab === "summary"} />
                </Tabs.TabPane>
                <Tabs.TabPane tab="Geçmiş Dönemler" key="pastPeriodsTab">
                    <MerchantPastPeriodsTab isTabOpened={activeTab === "pastPeriodsTab"} />
                </Tabs.TabPane>
            </TabsContainer>
        </CustomerCashOnDeliveryPageContainer>
    );
};
